import React, { memo, useCallback, useContext } from 'react'

import {
  Button,
  Icon,
  SearchGradient,
  ImageAIGradient,
  BrushAIGradient,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { iconSize } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { openImageAssistant, setEditImage } from 'Pods/ThreeDStudio/Store/actions/ui'
import { IMAGE_ASSISTANT_TAB } from 'Pods/ThreeDStudio/Store/constants'
import ThreeDStudioPageContext from 'Pods/ThreeDStudio/ThreeDStudioPageContext'

const searchIcon = <Icon svgComponent={SearchGradient} size={iconSize} notSpaced />
const createIcon = <Icon svgComponent={ImageAIGradient} size={iconSize} notSpaced />
const editIcon = <Icon svgComponent={BrushAIGradient} size={iconSize} notSpaced />

function IdeationActions() {
  const t = useTranslation()
  const { imageSearchOnIdeationFLowEnabled } = useContext(ThreeDStudioPageContext)
  const inputImage = useThreeDStudioStore(state => state.modelSettings.inputImage)
  const inputImageUrl = useThreeDStudioStore(state => state.modelSettings.inputImageUrl)
  const hasInputImage = !!inputImage

  const handleSearch = useCallback(() => openImageAssistant(IMAGE_ASSISTANT_TAB.SEARCH), [])
  const handleCreate = useCallback(() => openImageAssistant(IMAGE_ASSISTANT_TAB.CREATE), [])
  // Load the current input image (the upload preview) onto the Edit tab's canvas.
  const handleEdit = useCallback(() => {
    setEditImage({ id: inputImage, url: inputImageUrl })
    openImageAssistant(IMAGE_ASSISTANT_TAB.EDIT)
  }, [inputImage, inputImageUrl])

  return (
    <div className="image-uploader__ideation-actions">
      {imageSearchOnIdeationFLowEnabled && (
        <Button
          type="secondary"
          size="small"
          variant="with-icon"
          customClass="image-uploader__ideation-button"
          icon={searchIcon}
          onClick={handleSearch}
        >
          <span className="image-uploader__ideation-button-label">
            {t('shared.actionSelector.imageUploader.ideation.search')}
          </span>
        </Button>
      )}
      <Button
        type="secondary"
        size="small"
        variant="with-icon"
        customClass="image-uploader__ideation-button"
        icon={createIcon}
        onClick={handleCreate}
      >
        <span className="image-uploader__ideation-button-label">
          {t('shared.actionSelector.imageUploader.ideation.create')}
        </span>
      </Button>
      <Button
        type="secondary"
        size="small"
        variant="with-icon"
        customClass="image-uploader__ideation-button"
        icon={editIcon}
        onClick={handleEdit}
        disabled={!hasInputImage}
      >
        <span className="image-uploader__ideation-button-label">
          {t('shared.actionSelector.imageUploader.ideation.edit')}
        </span>
      </Button>
    </div>
  )
}

export default memo(IdeationActions)
